/**
 * Extension Message Listener
 * Listens for messages from Chrome Extension via window.postMessage
 */

/**
 * Initialize listener for extension messages
 * @param {Function} onLogout - Callback when logout message is received
 * @param {Function} onSignIn - Callback when sign-in message is received
 */
export function initializeExtensionListener(onLogout, onSignIn) {
  // Skip if not in browser
  if (typeof window === 'undefined') {
    console.log('[ExtensionListener] Not in browser');
    return;
  }

  // Listen for messages from extension content script
  window.addEventListener('message', (event) => {
    // Only accept messages from same origin
    if (event.origin !== window.location.origin) {
      return;
    }

    const message = event.data;

    if (message.type === 'EXTENSION_LOGOUT') {
      console.log('[ExtensionListener] Logout requested by extension');
      if (onLogout) {
        onLogout();
      }
    } else if (message.type === 'EXTENSION_SIGNED_IN') {
      console.log('[ExtensionListener] Sign-in notification from extension:', message.data);
      if (onSignIn) {
        onSignIn(message.data);
      }
    }
  });

  console.log('[ExtensionListener] ✓ Extension message listener initialized');
}
